// extracted by mini-css-extract-plugin
export var clauseRow = "_ex-6";
export var emptyState = "_ex-d";
export var filterContent = "_ex-a";
export var filterGroup = "_ex-1";
export var filterGroupContainer = "_ex-0";
export var nestedGroup = "_ex-2";
export var nestedGroupContent = "_ex-b";
export var nestedGroupDepth1 = "_ex-3";
export var nestedGroupDepth2 = "_ex-4";
export var nestedGroupDepth3 = "_ex-5";
export var nestedGroupEmpty = "_ex-c";
export var operatorAnd = "_ex-8";
export var operatorOr = "_ex-9";
export var operatorToggle = "_ex-7";
export var removeGroupButton = "_ex-e";